export function Item3() {
  return (
    <>
      <p className="text-lg font-medium text-blue-200 mt-6">
        Nossa abordagem em asset tracing é baseada em métodos inovadores e
        tecnologia de ponta, utilizada para a análise de bases de dados públicas
        nacionais e internacionais para realizar levantamentos de informações
        patrimoniais assertivas dos devedores.
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4">
        Nossa equipe especializada vale-se das melhores práticas de rastreamento
        de ativos para identificar bens ou direitos passíveis de penhora, além
        de evidências de possíveis fraudes praticadas em prejuízo do credor.
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4">
        Trabalhamos de forma diligente e estratégica para proteger os interesses
        de nossos clientes, fornecendo relatórios detalhados e análises robustas
        para embasar suas decisões, subsidiar negociações e garantir uma
        execução efetiva.
      </p>
    </>
  );
}
